import React from 'react';
import Spinner from 'react-scale/components/ui/spinner';

const ExampleLoading = ({ color = 'black' }) => (
  <div className="wrapper">
    <div className="spinner-wrapper">
      <Spinner />
    </div>
    <style jsx>{`
      .wrapper {
        background: ${color};
        width: 100%;
        height: 100%;
      }
      .spinner-wrapper {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(2);
      }
    `}</style>
  </div>
);

export default ExampleLoading;
